'use server'

import { apiRequest, ApiResponse } from '../request'

export interface EsocialEvent {
    id: number
    companyId: number
    eventType: string
    employeeId: number | null
    employeeName: string | null
    competence: string | null
    rubricId: number | null
    status: string
    xml: string | null
    signedXml: string | null
    protocol: string | null
    receipt: string | null
    batchId: number | null
    errorMessage: string | null
    createdAt: string
    updatedAt: string
}

export interface EsocialCertificate {
    id: number
    companyId: number
    name: string
    serialNumber: string | null
    issuer: string | null
    validFrom: string | null
    validTo: string | null
    active: boolean
    createdAt: string
}

export interface EsocialBatch {
    id: number
    companyId: number
    protocol: string | null
    status: string
    eventCount: number
    environment: string | null
    sentAt: string | null
    responseXml: string | null
    createdAt: string
}

const BASE = 'hr/esocial'

export async function getEvents(params?: {
    eventType?: string; status?: string
}): Promise<ApiResponse<EsocialEvent[]>> {
    return apiRequest<EsocialEvent[]>(`${BASE}/events`, { params: params || {} })
}

export async function getEvent(id: number): Promise<ApiResponse<EsocialEvent>> {
    return apiRequest<EsocialEvent>(`${BASE}/events/${id}`, {})
}

export async function generateEvent(data: {
    eventType: string; employeeId?: number; competence?: string; rubricId?: number
}): Promise<ApiResponse<EsocialEvent>> {
    return apiRequest<EsocialEvent>(`${BASE}/events/generate`, { data }, 'post')
}

export async function signEvent(id: number): Promise<ApiResponse<EsocialEvent>> {
    return apiRequest<EsocialEvent>(`${BASE}/events/${id}/sign`, {}, 'post')
}

export async function signBatch(eventIds: number[]): Promise<ApiResponse<any>> {
    return apiRequest<any>(`${BASE}/events/sign-batch`, { data: { eventIds } }, 'post')
}

export async function sendBatch(eventIds: number[], environment?: 'PRODUCTION' | 'RESTRICTED'): Promise<ApiResponse<EsocialBatch>> {
    return apiRequest<EsocialBatch>(`${BASE}/events/send`, { data: { eventIds, environment } }, 'post')
}

export async function consultBatch(batchId: number): Promise<ApiResponse<EsocialBatch>> {
    return apiRequest<EsocialBatch>(`${BASE}/batches/${batchId}/consult`, {}, 'post')
}

export interface CertificateStatus {
    hasCertificate: boolean
    certificate: {
        id: number
        serialNumber: string
        issuer: string
        subject: string
        cnpj: string
        validFrom: string
        validUntil: string
        status: string
    } | null
    expired: boolean
}

export async function getCertificateStatus(): Promise<ApiResponse<CertificateStatus>> {
    return apiRequest<CertificateStatus>(`${BASE}/certificates`, {})
}
